<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        <div>
                            <h3 class="headline mb-0">Connexion bancaire</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <div style="text-align: center">
                            <v-img src="../assets/icon_waiting_bank.svg" max-width="30%" />
                            <br /><br />
                            <p>
                                Votre compte bancaire est en cours de synchronisation, merci de
                                patienter...
                            </p>
                            <ul>
                                <li v-for="acc in accounts" :key="acc.id">{{ acc.name }}</li>
                            </ul>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import BANK_ACCOUNTS from "../graphql/bank/BankAccounts.gql";
import { BankAccount } from "../../../types";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class BudgetInsightCallback extends Vue {
    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    @Apollo(
        {
            query: BANK_ACCOUNTS,
            variables() {
                return {
                    companyId: this.selectedCompany.id,
                    type: "BANK",
                };
            },
            skip() {
                return !this.selectedCompany?.id;
            },
        },
        function (data) {
            if (data && data.bankAccounts && data.bankAccounts.length) {
                this.$apollo.addSmartQuery("bankAccount", {
                    query: gql`
                        query IsBankAccountSynced($bankAccountId: ID!) {
                            bankAccount(where: { id: $bankAccountId }) {
                                id
                                name
                                initialSyncDone
                            }
                        }
                    `,
                    variables() {
                        return {
                            bankAccountId: data.bankAccounts[0].id,
                        };
                    },
                    result: ({ data: result }) => {
                        console.log("account", result);
                        if (result && result.bankAccount && result.bankAccount.initialSyncDone) {
                            this.$router.replace({ name: "bank" });
                        }
                    },
                });
                return data.bankAccounts;
            }
            return [];
        },
    )
    accounts: BankAccount[] = [];
}

export default toNative(BudgetInsightCallback);
</script>
